const FileViewer = ({ publication_type, file, name, className = "", contained = false }) => {
  const wrapperClass = contained
    ? "w-full h-full min-h-0 overflow-hidden"
    : "w-full";

  const imageClass = contained
    ? "w-full h-full object-contain"
    : "w-full rounded-[10px]";
  const mediaClass = [imageClass, className].filter(Boolean).join(" ");

  const videoClass = contained
    ? "w-full h-full object-contain"
    : "w-full rounded-[10px]";

  return (
    <div className={wrapperClass}>
      {publication_type === "image" && (
        <img src={file} alt={name || "Post"} className={mediaClass} />
      )}
      {publication_type === "pdf" && (
        <iframe
          src={`${file}#toolbar=0`}
          title={name}
          className={`${mediaClass} h-[200px]`}
        />
      )}
      {(publication_type === "doc" || publication_type === "docx") && (
        <iframe
          src={`https://docs.google.com/gview?url=${encodeURIComponent(
            file
          )}&embedded=true`}
          title={name}
          className={`${mediaClass} h-[200px]`}
        />
      )}
      {publication_type === "video" && (
        <video src={file} controls className={[videoClass, className].filter(Boolean).join(" ")} />
      )}
      {publication_type === "audio" && (
        <div className="w-full rounded-[10px] flex items-center justify-center bg-gray-100 py-4">
          <audio src={file} controls className="w-full px-4" />
        </div>
      )}
    </div>
  );
};

export default FileViewer;
